import { getCurrentVersion, getUserIdRequestedApproval, getReleaseConfigMessage, noApproveCommentMessage, requestForReleaseApprovalMessage } from './ReportChangeLogPage.Helpers';
import { moduleColumn, moduleRefColumn, commonColumns } from '../../Common/Modals/ChangeLogModal/ChangeLogModal.Grid';
import actions from '../../../store/actions';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import ChangeLog from '../../Common/ChangeLog/ChangeLog';
import getColumns from './ReportChangeLogPage.Grid';
import GridRefresh from '../../../store/state/events/GridRefresh';
import history from '../../../infrastructure/helpers/react/history';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import identityStorage from '../../../infrastructure/authorization/identityStorage';
import IncrementVersionRequest from '../../../types/common/IncrementVersionRequest';
import React from 'react';
import store from '../../../store/store';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import VersionDisplay from '../../Common/VersionEditor/VersionDisplay';
import versionHelper from '../../../infrastructure/helpers/functions/common/versionHelper';
import writeUserRoles from '../../../infrastructure/constants/identity/writeUserRoles';
import CreateVersionModalState from '../../Common/Modals/CreateVersionModal/CreateVersionModalState';
import CreateVersionModal from '../../Common/Modals/CreateVersionModal/CreateVersionModal';
import RollBackVersionModal from '../../Common/Modals/RollbackVersionModal/RollBackVersionModal';
import RollbackVersionModalState from '../../Common/Modals/RollbackVersionModal/RollbackVersionModalState';
import Spinner from '../../Common/Spinner/Spinner';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import { ReactComponent as DownloadIcon } from '../../Common/BootstrapIcons/download.svg';
import DownloadModal from '../../Common/Modals/DownloadModal/DownloadModal';
import ChangeDescription from '../../../infrastructure/types/DifferenceVisualizer/ChangeDescription';
import DiffModal from '../../Common/Modals/DiffModal/DiffModal';
import VersionStatus from '../../../types/common/VersionStatus';
import WarningModal from '../../Common/Modals/WarningModal/WarningModal';
import adminUserRoles from '../../../infrastructure/constants/identity/adminRoles';
import { isPendingApproval } from './ReportPage/ReportPage.Helpers';
import RequestForRelease from '../../../types/report/RequestForRelease';
import FormGroup from '../../Common/FormGroup/FormGroup';
import Modal from '../../Common/Modal/Modal';
import PromiseButton from '../../Common/PromiseButton';
import InformationModal from '../../Common/Modals/InformationModal/InformationModal';
import messageHelper from '../../Common/Message/MessageHelper';
import resolveConfig from '../../../infrastructure/configuration/resolveConfig';
import { AxiosResponse } from 'axios';

const gridName = 'reporting-change-log';

interface State {
    isWaiting: boolean;
    version: string;
    showSpinner: boolean;
    showDownloadPopup: boolean;
    changes: ChangeDescription;
    showChangesDiffPopup: boolean;
    showWarningModal: boolean;
    error: string;
    canApproveRequest: boolean;
    isWaitingForApproval: boolean;
    showAprroveReleaseButtons: boolean;
    popupMessage: string;
    showRejectModal: boolean;
    rejectComment: string;
    rejectErrorMessage: string;
    showInformationModal: boolean;
    showDatasourceFieldsMissingModal: boolean;
    rollbackIdentifier: string;
    rollbackComment: string;
    rollbackName: string;
    rollBackError: string;
}

class ReportChangeLogPage extends React.Component<any, State> {
    private id: number;
    private name: string;
    private redirectRoute: string;
    private validQueryParams: boolean;
    private isFourEyesReleaseProcessEnabled: boolean;

    constructor(props: any) {
        super(props);

        let query = urlHelper.deserializeQuery(history.location.search);

        this.id = parseInt(query['id']);
        this.name = query['name'];
        this.isFourEyesReleaseProcessEnabled = query['isFourEyesReleaseProcessEnabled'] === 'true';
        this.redirectRoute = query['redirect'];

        this.validQueryParams =
            typeHelper.isNumber(this.id) &&
            typeHelper.isString(this.redirectRoute);

        if (!this.validQueryParams) {
            history.push(appRoutes.home);
        }

        this.state = {
            isWaiting: true,
            version: '',
            showSpinner: false,
            showDownloadPopup: false,
            changes: {} as ChangeDescription,
            showChangesDiffPopup: false,
            showWarningModal: false,
            error: '',
            canApproveRequest: false,
            isWaitingForApproval: false,
            showAprroveReleaseButtons: false,
            popupMessage: '',
            showRejectModal: false,
            rejectComment: '',
            rejectErrorMessage: '',
            showInformationModal: false,
            showDatasourceFieldsMissingModal: false,
            rollbackIdentifier: '',
            rollbackComment: '',
            rollbackName: '',
            rollBackError: ''
        };

        this.getCurrentVersion = this.getCurrentVersion.bind(this);
        this.onGetCurrentVersionSuccess = this.onGetCurrentVersionSuccess.bind(this);
        this.openIncrementVersionModal = this.openIncrementVersionModal.bind(this);
        this.onIncrementVersionSuccess = this.onIncrementVersionSuccess.bind(this);
        this.redirect = this.redirect.bind(this);
        this.openRollBackModal = this.openRollBackModal.bind(this);
        this.onDownloadTypeSelected = this.onDownloadTypeSelected.bind(this);
        this.onShowDiffClick = this.onShowDiffClick.bind(this);
        this.onWarningReleaseModalAccepted = this.onWarningReleaseModalAccepted.bind(this);
        this.onSaveVersionNameCommentPopup = this.onSaveVersionNameCommentPopup.bind(this);
        this.onReleaseButtonClick = this.onReleaseButtonClick.bind(this);
        this.onRejectPopupButtonClick = this.onRejectPopupButtonClick.bind(this);
        this.onApproveClick = this.onApproveClick.bind(this);
        this.onCloseRejectPopup = this.onCloseRejectPopup.bind(this);
        this.onRollBackError = this.onRollBackError.bind(this);
        this.onMissingFieldsPopupOkButtonClick = this.onMissingFieldsPopupOkButtonClick.bind(this);
    }

    async componentDidMount(): Promise<void> {

        if (!this.validQueryParams) {
            return;
        }

        this.getCurrentVersion();

        let isWaitingForApproval = await isPendingApproval(this.id)

        this.setState({ isWaitingForApproval });

        if (isWaitingForApproval) {
            this.validateUser();
        }
    }

    getCurrentVersion(): void {

        getCurrentVersion(this.id).then(response => this.onGetCurrentVersionSuccess(response.data.value));
    }

    async validateUser(): Promise<void> {

        let userDetails = identityStorage.get();

        let userRequestedApproval = await getUserIdRequestedApproval(this.id);
        if (userRequestedApproval) {
            if (userRequestedApproval !== userDetails.userId && adminUserRoles.includes(userDetails.userRole)) {
                this.setState({ canApproveRequest: true, showAprroveReleaseButtons: true });
            }
            else {
                this.setState({ showInformationModal: true, canApproveRequest: false, showAprroveReleaseButtons: false });
            }
        }
        else {
            this.setState({ canApproveRequest: false, showAprroveReleaseButtons: false });
        }
    }

    onGetCurrentVersionSuccess(version: string): void {

        let changes = { isWaiting: false, version: version } as State;

        this.setState(changes);
    }

    openIncrementVersionModal(isReleased: boolean, isRequestForApproval: boolean): void {

        let payload: CreateVersionModalState = {
            isOpen: true,
            title: isReleased ? 'Releasing config' : 'Increment Version',
            buttonName: this.isFourEyesReleaseProcessEnabled && isRequestForApproval && isReleased ? 'Request for Approval' : 'Save',
            nameAndCommentAreRequired: isReleased,
            name: '',
            comment: '',
            onSaveClick: (name: string, comment: string) => this.onSaveVersionNameCommentPopup(isReleased, name, comment),
            error: null
        };

        store.dispatch({ type: actions.createVersionModal.open, payload: payload });
    }

    async onSaveVersionNameCommentPopup(isReleased: boolean, name: string, comment: string) {

        if (!isReleased) {
            await this.incrementVersion(false, name, comment, VersionStatus.NA);
        }
        else {
            let isFourEyesReleaseEnabled = false;

            try {
                let response = await httpClient.getWithAsyncAwait('report/for-eyes-release');

                isFourEyesReleaseEnabled = response.data;
            }
            catch { }
            finally {
                if (isFourEyesReleaseEnabled) {
                    let identifier = versionHelper.incrementMajorVersion(this.state.version);

                    let url = urlHelper.buildRoute(['report-version', this.id, 'request-for-approve-release', identifier]);

                    let config = resolveConfig();

                    let requestForRelease = {
                        name,
                        comment,
                        environment: config.env.name

                    } as RequestForRelease;

                    await httpClient.post(url, requestForRelease);
                }
                else {
                    this.incrementVersion(true, name, comment, VersionStatus.NA);
                }
            }
            let payload: GridRefresh = {
                uniqueName: gridName,
                useCurrentPage: true
            };

            store.dispatch({ type: actions.grid.refresh, payload: payload });

            this.setState({ canApproveRequest: false, isWaitingForApproval: isFourEyesReleaseEnabled });
        }
    }

    async incrementVersion(isReleased: boolean, name: string, comment: string, status: VersionStatus) {

        let versionStatus = Object.keys(VersionStatus)[Object.values(VersionStatus).indexOf(status)];

        let url = urlHelper.buildRoute(['report', this.id, this.state.version]);

        await httpClient.post(url, { isReleased: isReleased, name: name, comment: comment, versionStatus } as IncrementVersionRequest);

        await this.onIncrementVersionSuccess();
    }

    async onIncrementVersionSuccess() {

        await this.getCurrentVersion();

        let payload: GridRefresh = {
            uniqueName: gridName,
            useCurrentPage: false
        };

        store.dispatch({ type: actions.grid.refresh, payload: payload });
    }

    redirect(): void {

        history.push(decodeURIComponent(this.redirectRoute));
    }

    onRollBackError(res: AxiosResponse, version: string) {

        let aggregationFieldsMessage = "The following data source fields are missing:";

        if (res.data.message.startsWith(aggregationFieldsMessage)) {

            let fieldNames = res.data.message.substring(aggregationFieldsMessage.length);

            let rollBackError = `Config "${this.name}" v${version} doesn't have the following fields: ${fieldNames}.\r\n
            During roll back these fields will be added to aggregation.datasources and will have a default value`;

            let comment = `Fields ${fieldNames} have been added by system during roll back`;

            this.setState({ showDatasourceFieldsMissingModal: true, rollBackError, rollbackIdentifier: version, rollbackComment: comment })
        }
        else {
            messageHelper.showMesage(res.data.message, true);
        }
    }

    openRollBackModal(): void {

        var getVersionsRoute = urlHelper.buildRoute(['report-version', this.id, 'list']);

        httpClient.get<string[]>(getVersionsRoute).then((response) => {

            let payload: RollbackVersionModalState = {
                isOpen: true,
                title: 'Roll Back',
                name: '',
                comment: '',
                versions: response.data,
                selectedVersion: response.data[0],
                onSaveClick: (identifier: string, name: string, comment: string) => {
                    this.setState({ rollbackName: name, rollbackComment: this.state.rollbackComment || comment });
                    let route = urlHelper.buildRoute(['report', this.id, 'rollback', identifier]);
                    return httpClient.postSimple(route, { name: name, comment: comment } as IncrementVersionRequest).then(this.onIncrementVersionSuccess)
                        .catch((err) => this.onRollBackError(err.response, identifier))
                },
                error: null
            };

            if (payload.versions.length > 0) {

                payload.selectedVersion = payload.versions[0];
                payload.name = `Roll Back to V${payload.selectedVersion}`;
            }

            store.dispatch({ type: actions.rollBackVersionModal.open, payload: payload });
        });
    }

    async onDownloadTypeSelected(downloadAsFragmented: boolean): Promise<void> {

        this.setState({ showSpinner: true, showDownloadPopup: false });

        let downloadVersionsRoute = urlHelper.buildRoute(['report-version', this.id, downloadAsFragmented ? 'export-fragmented' : 'export-full', 'download']);

        await httpClient.download(downloadVersionsRoute, {});

        this.setState({ showSpinner: false });
    }

    onShowDiffClick(value: ChangeDescription) {
        this.setState({ showChangesDiffPopup: true, changes: value });
    }

    async getRequestForRelease(): Promise<RequestForRelease> {

        let url = urlHelper.buildRoute(['report-version', this.id, 'request-for-release']);

        let res = await httpClient.get<RequestForRelease>(url);

        return res.data;
    }

    onWarningReleaseModalAccepted() {
        this.setState({ showWarningModal: false });
        this.openIncrementVersionModal(true, true);
    }

    onReleaseButtonClick() {
        if (!this.state.isWaitingForApproval) {

            let popupMessage = getReleaseConfigMessage(this.name);

            this.setState({ showWarningModal: true, popupMessage });
        }
    }

    async onApproveClick() {

        let requestForRelease = await this.getRequestForRelease();

        let url = urlHelper.buildRoute(['report-version', this.id, 'approve-request-for-release', this.state.version]);

        let payload = {
            comment: requestForRelease.comment,
            name: requestForRelease.name
        } as RequestForRelease

        let response = await httpClient.put(url, payload);

        if (!response.data) {
            messageHelper.showMesage('This user cannot approve.', false);
        }
        else {
            await this.incrementVersion(true, requestForRelease.name, requestForRelease.comment, VersionStatus.Approved);
        }

        this.setState({ isWaitingForApproval: false, canApproveRequest: false, showAprroveReleaseButtons: false });
    }

    async onRejectPopupButtonClick() {

        if (!this.state.rejectComment) {
            this.setState({ rejectErrorMessage: 'Comment is required.' })
        }
        else {
            const rejectedName = 'Rejected Release';


            let url = urlHelper.buildRoute(['report-version', this.id, 'reject-request-for-release']);

            let payload = {
                comment: this.state.rejectComment,
                name: rejectedName
            } as RequestForRelease

            let response = await httpClient.put(url, payload);

            if (!response.data) {
                messageHelper.showMesage('This user cannot reject.', false);
            }
            else {
                await this.incrementVersion(false, rejectedName, this.state.rejectComment, VersionStatus.Rejected);

                this.setState({ isWaitingForApproval: false, canApproveRequest: false, showAprroveReleaseButtons: false, showRejectModal: false });
            }
        }
    }

    onCloseRejectPopup() {
        this.setState({ rejectComment: '', rejectErrorMessage: '', showRejectModal: false, isWaitingForApproval: true, showAprroveReleaseButtons: true });
    }

    async onMissingFieldsPopupOkButtonClick() {


        let url = urlHelper.buildRoute(['report-version', this.id, 'aggregation/missing-fields', this.state.rollbackIdentifier]);

        await httpClient.put(url, {});

        let route = urlHelper.buildRoute(['report', this.id, 'rollback', this.state.rollbackIdentifier]);


        httpClient.postSimple(route, { name: this.state.rollbackName, comment: this.state.rollbackComment } as IncrementVersionRequest)
            .then(this.onIncrementVersionSuccess)
            .catch((err) => this.onRollBackError(err.response, this.state.rollbackIdentifier))

        this.setState({ showDatasourceFieldsMissingModal: false });
    }

    render(): JSX.Element {

        if (!this.validQueryParams) {
            return (<></>);
        }

        let identity = identityStorage.get();

        let isDisabled = this.state.isWaitingForApproval;

        let releaseVersion = <VersionDisplay version={this.state.version} majorIncremented={true} />

        return (
            <>
                {
                    writeUserRoles.includes(identity.userRole) &&
                    <>
                        <h4 >Version Management</h4>
                        {
                            !this.state.isWaiting &&
                            <div className="display-flex margin-top-bottom-20px">
                                {!isDisabled &&
                                    <div>
                                        <button className="btn cb-btn" disabled={isDisabled} onClick={() => this.openIncrementVersionModal(false, false)}>
                                            <span>Create Version </span>
                                            <VersionDisplay version={this.state.version} majorIncremented={false} />
                                        </button>
                                        <button disabled={versionHelper.isReleasedVersion(this.state.version) || (!adminUserRoles.includes(identity.userRole) && !this.state.isWaitingForApproval)} className="btn cb-btn" onClick={this.onReleaseButtonClick}>
                                            <span>Release as {releaseVersion}</span>
                                        </button>
                                        <button disabled={isDisabled} className="btn cb-btn" onClick={this.openRollBackModal}>
                                            <span>Roll Back</span>
                                        </button>
                                    </div>
                                }
                                {this.state.showAprroveReleaseButtons &&
                                    <div className='display-flex'>
                                        <button className="btn cb-btn bg-green-important" onClick={this.onApproveClick}>
                                            Approve Release {releaseVersion}
                                        </button>
                                        <button className="btn cb-btn bg-red-important" onClick={() => this.setState({ showRejectModal: true, isWaitingForApproval: false, showAprroveReleaseButtons: false })}>
                                            Reject Release {releaseVersion}
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                    </>
                }

                <div className='display-flex width-180px justify-content-start margin-bottom-10px align-items-center'>
                    <h4 className='margin-right-10px margin-bottom-0'>Change Log</h4>
                    {
                        this.state.showSpinner ?
                            <div>
                                <Spinner />
                            </div> :
                            <button className="custom-icon-button" onClick={() => this.setState({ showDownloadPopup: true })}>
                                <CustomIcon icon={DownloadIcon} title={iconTooltip.download} />
                            </button>
                    }
                </div>
                <ChangeLog
                    hasWriteAccess={writeUserRoles.includes(identity.userRole)}
                    reportConfigId={this.id}
                    getColumns={getColumns}
                    modalColumns={[moduleColumn, moduleRefColumn].concat(commonColumns(this.onShowDiffClick))}
                    backendRoute={urlHelper.buildRoute(['report-version', this.id])}
                    uniqueName={gridName}
                    isDisabled={isDisabled}
                />

                <div className="mt-3 mb-3">
                    <button onClick={this.redirect} className='btn btn-light'>Back</button>
                </div>

                <DownloadModal
                    onClose={() => { this.setState({ showDownloadPopup: false }) }}
                    onDownload={this.onDownloadTypeSelected}
                    isOpen={this.state.showDownloadPopup}
                    showVersionSelection={false} />
                <CreateVersionModal />
                <RollBackVersionModal />
                {
                    this.state.showChangesDiffPopup &&
                    <DiffModal
                        left={this.state.changes.previous}
                        right={this.state.changes.current}
                        title='Changes'
                        onClose={() => this.setState({ showChangesDiffPopup: false })}
                    />
                }
                {
                    this.state.showWarningModal &&
                    <WarningModal
                        onOkClick={this.onWarningReleaseModalAccepted}
                        onCancelClick={() => this.setState({ showWarningModal: false })}
                        message={this.state.popupMessage}
                        title={'Releasing config'}
                    />
                }
                {
                    this.state.showRejectModal &&

                    <Modal state={{ error: this.state.rejectErrorMessage, title: 'Reject release', isOpen: this.state.showRejectModal }} close={this.onCloseRejectPopup}>
                        <FormGroup label='Comment:' labelClassName={'col-3'} contentClassName={'col-9'}>
                            <textarea
                                className='form-control'
                                onChange={(e: any) => this.setState({ rejectComment: e.target.value })}
                                value={this.state.rejectComment}>
                            </textarea>
                        </FormGroup>

                        <PromiseButton className='btn cb-btn' text={'Reject'} enableOnErrorOnly={false} task={this.onRejectPopupButtonClick} />
                    </Modal>
                }
                {this.state.isWaitingForApproval &&
                    <InformationModal
                        message={requestForReleaseApprovalMessage}
                        title=''
                        onOkClick={() => this.setState({ showInformationModal: false })}

                    />
                }
                {
                    this.state.showDatasourceFieldsMissingModal &&
                    <WarningModal
                        message={this.state.rollBackError}
                        title=''
                        onOkClick={this.onMissingFieldsPopupOkButtonClick}
                        onCancelClick={() => this.setState({ showDatasourceFieldsMissingModal: false })}
                    />
                }
            </>
        );
    }
}

export default ReportChangeLogPage;
